import React from 'react';
import DmaStage from '../components/DmaStage';
import DmaStep from '../components/DmaStep';
import { useLanguage } from 'src/common/hooks';
import { ImageSlider } from '../components/ImageSlider';
import { generateImageUrls } from '../utils';
import LightTooltip from 'src/components/LightTooltip';
import { Link } from 'react-router-dom';
import { IconButton } from '@mui/material';
import { FactCheck } from '@mui/icons-material';

export default function Stage1() {
  const { t, language: l } = useLanguage({ keyPrefix: 'esg:dma' });
  return (
    <DmaStage
      title={t('stagesV2.informationOverview.title')}
      subtitle={t('stagesV2.informationOverview.subtitle')}
      color="#A1DF76"
    >
      <DmaStep
        title={t('stagesV2.informationOverview.steps.1')}
        disabled
        // TODO
      />
      <DmaStep
        title={t('stagesV2.informationOverview.steps.2')}
        videoComponent={<ImageSlider images={generateImageUrls(l, 3, 4)} />}
      />
      <DmaStep title={t('stagesV2.informationOverview.steps.3')} />
      <DmaStep
        title={t('stagesV2.informationOverview.steps.3_1')}
        navigateTo="../../questionnaires/BP-1"
        substep
      />
      <DmaStep
        title={t('stagesV2.informationOverview.steps.3_2')}
        navigateTo="../../questionnaires/GOV-1"
        substep
      />
      <DmaStep
        title={t('stagesV2.informationOverview.steps.3_3')}
        navigateTo="../../questionnaires/GOV-2"
        substep
      />
      <DmaStep
        title={t('stagesV2.informationOverview.steps.3_4')}
        navigateTo="../../questionnaires/GOV-3"
        substep
      />
      <DmaStep
        title={t('stagesV2.informationOverview.steps.3_5')}
        navigateTo="../../questionnaires/GOV-5"
        substep
      />
      <DmaStep
        title={t('stagesV2.informationOverview.steps.4')}
        videoComponent={<ImageSlider images={generateImageUrls(l, 7, 10)} />}
      />
      <DmaStep
        title={t('stagesV2.informationOverview.steps.5')}
        navigateToComponent={
          <LightTooltip title={t('step.step2TopicEvaluationButton.toggle')}>
            <Link to="./step-1">
              <IconButton>
                <FactCheck />
              </IconButton>
            </Link>
          </LightTooltip>
        }
      />
    </DmaStage>
  );
}
